module.exports = __webpack_public_path__ + "img/BS30.7dd9a389.svg";